import { render } from "./ResultClients.vue?vue&type=template&id=87adce56&ts=true"
import script from "./ResultClients.vue?vue&type=script&lang=ts"
export * from "./ResultClients.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__